import React, { ComponentProps } from 'react';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { Table, TableBody, TableCell, TableHead, TableRow } from '../../components/organisms/Table';
import { PageTrashTableRow, TrashedPage } from './partials/PageTrashTableRow';

type PageTrashProps = { pages: TrashedPage[] };

function PageTrash(embedded: PageTrashProps) {
  const { t } = useSonTranslation('PageTrash');

  if (embedded.pages && embedded.pages.length > 0) {
    return (
      <Table caption={t('table.caption')}>
        <TableHead>
          <TableRow>
            <TableCell>{t('table.tableHead.pageInformation')}</TableCell>
            <TableCell>{t('table.tableHead.numberOfChildPages')}</TableCell>
            <TableCell>{t('table.tableHead.trashDate')}</TableCell>
            <TableCell>{t('table.tableHead.trashedBy')}</TableCell>
            <TableCell>{t('table.tableHead.finalDeletionDate')}</TableCell>
            <TableCell>{t('table.tableHead.actions')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {embedded.pages.map((page: TrashedPage) => (
            <PageTrashTableRow key={page.pageId} {...page} />
          ))}
        </TableBody>
      </Table>
    );
  }
  return <p className="page-trash-block__no-pages">{t('noPages')}</p>;
}

export const PageTrashBlock = asBlock(PageTrash, BlockType.pagetrash);
export type PageTrashBlock = ComponentProps<typeof PageTrashBlock>;
